import { render, staticRenderFns } from "./achievementItem.vue?vue&type=template&id=172a51d6&scoped=true"
import script from "./achievementItem.vue?vue&type=script&lang=js"
export * from "./achievementItem.vue?vue&type=script&lang=js"
import style0 from "./achievementItem.vue?vue&type=style&index=0&id=172a51d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172a51d6",
  null
  
)

export default component.exports